// @flow
import * as React from "react"
import ReactDOM from "react-dom"
import { Spring, animated } from "react-spring"

export type tOverlay = {
  isActive: boolean,
  children: React.Node,
  rootId?: string,
  className?: string,
  style?: {}
}

export type tOverlayState = {
  scrollTop: number,
  prevScrollTop: number
}

export class Overlay extends React.Component<tOverlay, tOverlayState> {
  bodyActiveClass = "component-overlay-is-active"
  root: HTMLElement | null
  mount: HTMLElement | null
  state = {
    scrollTop: 0,
    prevScrollTop: 0
  }
  constructor(props: tOverlay) {
    super(props)
    let rootId = this.props.rootId ? this.props.rootId : "root"

    if (typeof document !== "undefined") {
      this.root = document.getElementById(rootId)
      this.mount = document.createElement("div")

      if (!this.root)
        // eslint-disable-next-line no-console
        console.warn(
          `Overlay component could not mount itself to the rootId of ${rootId}`
        )
    }
  }
  componentDidMount() {
    if (typeof document !== "undefined") {
      window.addEventListener("scroll", this.handleScroll, false)
      if (this.root && this.mount) this.root.appendChild(this.mount)
    }
  }
  componentWillUnmount() {
    if (typeof document !== "undefined") {
      window.removeEventListener("scroll", this.handleScroll, false)
      if (this.root && this.mount) this.root.removeChild(this.mount)
    }
  }

  componentDidUpdate(prevProps: tOverlay, prevState: tOverlayState) {
    if (typeof document !== "undefined") {
      // overlay was active, but is about to not be
      if (prevProps.isActive && !this.props.isActive) {
        window.scrollTo(0, prevState.prevScrollTop)

        document
          .getElementsByTagName("body")[0]
          .classList.remove(this.bodyActiveClass)
        // overlay wasn't active, but is about to be
      } else if (!prevProps.isActive && this.props.isActive) {
        //         window.scrollTo(0, this.state.scrollTop)
        this.setState({ prevScrollTop: prevState.scrollTop })
        window.scrollTo(0, 0)

        document
          .getElementsByTagName("body")[0]
          .classList.add(this.bodyActiveClass)
      }
    }
  }

  handleScroll = () => {
    if (typeof document !== "undefined") {
      const scrollTop =
        window.pageYOffset ||
        (document.documentElement ? document.documentElement.scrollTop : 0)

      this.setState({
        scrollTop
      })
    }
  }

  render() {
    return this.props.isActive && this.mount
      ? ReactDOM.createPortal(
          <Spring from={{ opacity: 0 }} to={{ opacity: 1 }} native>
            {(styles) => (
              <animated.div
                data-testid="component-overlay"
                style={{
                  ...styles,
                  ...(this.props.style ? this.props.style : {})
                }}
                className={this.props.className ? this.props.className : ""}
              >
                {this.props.children}
              </animated.div>
            )}
          </Spring>,
          this.mount
        )
      : null
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Overlay.js